"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePassword = exports.updateUserProfile = exports.getUsers = exports.getUser = exports.addUser = exports.getCurrentUser = void 0;
const getCurrentUser = async (supabase) => {
    const { data: { user }, } = await supabase.auth.getUser();
    const { data: profile } = await supabase
        .from("user_profiles")
        .select("id, first_name, last_name")
        .eq("id", user?.id)
        .single();
    return profile;
};
exports.getCurrentUser = getCurrentUser;
const addUser = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("user_profiles")
        .insert(obj)
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addUser = addUser;
const getUser = async (supabase, id) => {
    const { data, error } = await supabase
        .from("user_profiles")
        .select("id, ref, first_name, last_name, email, phone, display_currency, user_type, orders!client_id(*, order_lines!order_id(*)), created_at")
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getUser = getUser;
const getUsers = async (supabase) => {
    const { data, error } = await supabase
        .from("user_profiles")
        .select("id, first_name, last_name, email, phone, display_currency, user_type, orders!client_id(*, order_lines!order_id(*))");
    if (!error)
        return data;
    return error;
};
exports.getUsers = getUsers;
const updateUserProfile = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("user_profiles")
        .update(obj)
        .eq("id", obj.id)
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateUserProfile = updateUserProfile;
const updatePassword = async (supabase, password) => {
    const { data } = await supabase.auth.updateUser({
        password,
    });
    return data;
};
exports.updatePassword = updatePassword;
